import { Link } from "react-router-dom";

import { RenderWhen } from "../../../../../../components";
import Typography from "../../../../../../components/typography/Typography";
import { PAGE_PATH } from "../../../../../../path";
import { FileIndicator } from "../../../../@types";
import { SECTIONS } from "../../../../consts";
import commonStyles from "../../../../containers/report_summary/report-summary.module.scss";
import { pathToSS } from "../../../../util";

import styles from "./static-analysis-insights.module.scss";

interface Props {
  fileIndicators: FileIndicator;
  sourceId?: number;
}

const StaticAnalysisInsightsIndicators = ({
  fileIndicators,
  sourceId
}: Props) => (
  <div className={styles.file_indicators}>
    <div>
      {fileIndicators.indicators.slice(0, 2).map(indicator => (
        <RenderWhen
          key={`${fileIndicators.sha1}_${indicator.id}`}
          condition={!!indicator.id}
          fallback={
            <Typography
              variant={"body1"}
              className={styles.indicator}
              title={indicator.description}
            >
              {indicator.description}
            </Typography>
          }
        >
          <Link
            to={`${PAGE_PATH.SEARCH}?q=indicators:${indicator.id}`}
            className={styles.indicator}
            style={{ textDecoration: "underline" }}
            title={indicator.description}
            data-testid={`report_summary_static_analysis_indicator_link_${indicator.id}`}
          >
            {indicator.description}
          </Link>
        </RenderWhen>
      ))}
    </div>
    <RenderWhen condition={!!fileIndicators.event_count}>
      <Link
        to={pathToSS(
          fileIndicators.sha1,
          sourceId,
          SECTIONS.TI_CORE.INDICATORS,
          fileIndicators.relationship_id
        )}
        className={commonStyles.link}
        style={{ flexShrink: 0 }}
        data-testid="report_summary_static_analysis_indicators_more_link"
      >{`+${fileIndicators.event_count} More`}</Link>
    </RenderWhen>
  </div>
);

export default StaticAnalysisInsightsIndicators;
